<div class="modal fade show" [class.d-block]="showModal" tabindex="-1" role="dialog" *ngIf="showModal">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title">
          <i class="bx bx-time me-2"></i>
          Session Timeout Warning
        </h5>
      </div>
      <div class="modal-body text-center">
        <div class="mb-3">
          <i class="bx bx-time-five warning-icon"></i>
        </div>
        <h5 class="mb-3">Your session is about to expire</h5>
        <p class="text-muted mb-3">
          You have been inactive for a while. Your session will expire in:
        </p>
        <div class="countdown-display mb-4">
          <span class="countdown-time">{{ formatTime(secondsRemaining) }}</span>
        </div>
        <p class="text-muted">
          Click "Stay Logged In" to continue your session, or you will be automatically logged out.
        </p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary btn-lg" (click)="stayLoggedIn()">
          <i class="bx bx-check me-2"></i>
          Stay Logged In
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showModal"></div>


